<template>
  <v-col :cols="12" style="margin-top: -30px" :class="{'pb-0': true, 'pr-0': true, 'px-0': $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'}">
    <material-card
      class="card-tabs"
      color="green"
    >
      <template v-slot:header>
        <v-tabs background-color="transparent" slider-color="white" :centered="true" v-model="comments.tab">
          <v-tab :key="`communication`">
            <v-icon class="mr-2">
              mdi-cloud
            </v-icon>
            Communication
          </v-tab>
          <v-tab v-if="$store.state.auth.checkAccess({key: 'document_link', value: true})" :key="`kyc-details`">
            <v-icon class="mr-2">
              mdi-account-details
            </v-icon>
            KYC Details
          </v-tab>
          <v-tab v-if="$store.state.auth.checkAccess({key: 'document_link', value: true})" :key="`documents`">
            <v-icon class="mr-2">
              mdi-account-details
            </v-icon>
            Documents
          </v-tab>
          <v-tab :key="`iovation`">
            <v-icon class="mr-2">
              mdi-content-duplicate
            </v-icon>
            Iovation
          </v-tab>
          <v-tab :key="`kyc`">
            <v-icon class="mr-2">
              mdi-code-tags
            </v-icon>
            KYC
          </v-tab>
          <v-tab :key="`vip`">
            <v-icon class="mr-2">
              mdi-code-tags
            </v-icon>
            VIP
          </v-tab>
          <v-tab
            v-if="$store.state.auth.checkAccess({ key: 'task_view', value: true})"
          >
            <v-icon class="mr-2">
              assignment
            </v-icon>
            Tasks
          </v-tab>
        </v-tabs>
      </template>

      <v-tabs-items v-model="comments.tab">
        <v-tab-item :key="`communication`">
          <comments-table :isActionAllowed="false" type="communication" @show-manual-notification="$emit('show-manual-notification')" :with-manual-notification-button="true"></comments-table>
        </v-tab-item>
        <v-tab-item v-if="$store.state.auth.checkAccess({key: 'document_link', value: true})" :key="`kyc-details`">
          <automatic-kyc />
        </v-tab-item>
        <v-tab-item v-if="$store.state.auth.checkAccess({key: 'document_link', value: true})" :key="`documents`">
          <documents />
        </v-tab-item>
        <v-tab-item :key="`iovation`">
          <iovation />
        </v-tab-item>
        <v-tab-item :key="`kyc`">
          <comments-table type="kyc" @show-manual-notification="$emit('show-manual-notification')" :with-manual-notification-button="true"></comments-table>
        </v-tab-item>
        <v-tab-item :key="`vip`">
          <comments-table type="vip" @show-manual-notification="$emit('show-manual-notification')" :with-manual-notification-button="true"></comments-table>
        </v-tab-item>
        <v-tab-item
          v-if="$store.state.auth.checkAccess({ key: 'task_view', value: true})"
          key="tasks"
        >
          <tasks />
        </v-tab-item>
      </v-tabs-items>
    </material-card>
  </v-col>
</template>

<script>
  import { mask } from 'vue-the-mask'
  import CommentsTable from './comments/CommentsTable'
  import AutomaticKyc from './comments/AutomaticKYC'
  import Iovation from './comments/Iovation'
  import Documents from './comments/Documents'
  import Tasks from './comments/Tasks'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      CommentsTable,
      AutomaticKyc,
      Iovation,
      Documents,
      Tasks
    },
    directives: {
      mask,
    },
    props: [],

    data: () => ({}),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', comments: 'account/comments' }),
    },

    created () {
    },

    methods: {},

  }
</script>
